'use client'

import { useAppXClientHeader } from '@/feature/app/hooks/useAppXClientHeader'
import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs'
import type { RuntimeVariables } from '../_helpers/getEnvironmentHeaders'
import { makeApolloBrowserClient } from '../clients/apolloClient.client'

export function ApolloAppProvider({
  children,
  runtimeVariables,
}: {
  children: React.ReactNode
  runtimeVariables: RuntimeVariables
}) {
  const xClientValue = useAppXClientHeader()

  return (
    <ApolloNextAppProvider
      makeClient={() => makeApolloBrowserClient(runtimeVariables, xClientValue)}
    >
      {children}
    </ApolloNextAppProvider>
  )
}
